<template>
  <div class="usage-bar" :data-title="$t('plans.dataUsageLabel')">
    <p>{{ $t('plans.imagesCount', { count: imageTotal }) }}</p>

    <a class="btn btn-secondary" :href="plansUrl" target="_blank" data-test="anchorUsagePlans">
      <IconInfo/>
      {{ $t('plans.learnMore') }}
    </a>
  </div>
</template>

<style lang="scss" scoped>
.usage-title {
  color:                       var(--Brand-Primary);
  font-size:                   var(--font-size-10);
  font-weight:                 500;
  text-align:                  center;
  letter-spacing:              1.5px;
  line-height:                 normal;
  text-transform:              uppercase;
  margin-bottom:               5px;
}

.usage-bar {
  display:                     flex;
  flex-direction:              row;
  flex-wrap:                   nowrap;
  justify-content:             space-between;
  align-items:                 center;
  gap:                         10px;
  height:                      30px;
  padding:                     4px 4px 4px 10px;
  border:                      1.5px solid var(--Shades-30);
  background:                  var(--Shades-W);

  &,
  .btn-secondary {
    @include                   border_radius(99px);
  }

  p {
    font-weight:               600;
  }

  p,
  .btn-secondary {
    color:                     var(--Shades-90);
    font-size:                 var(--font-size-14);
    letter-spacing:            0.7px;
    text-wrap:                 nowrap;
    line-height:               normal;
    margin:                    0;
  }

  .btn-secondary {
    font-weight:               400;
    display:                   flex;
    align-items:               center;
    gap:                       5px;
    min-height:                unset;
    padding:                   3px 6px 3px 4px;
    border-width:              0;
    background:                var(--Shades-60-Border);

    svg {
      width:                   14px;
      height:                  14px;

      * {
        fill:                  var(--Shades-90);
      }
    }
  }
}

@media (max-width: 991px) {
  .usage-bar {
    @include                   border_radius(0);
    flex-direction:            row;
    height:                    28px;
    margin:                    0;
    padding:                   3px 10px 0;
    background:                var(--Shades-10);
    border:                    0;
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'
import { useSubscriptionStore } from '@/store/subscription'

export default {
  name: 'MenuUsageBar',
  computed: {
    userStore() {
      return useUserStore();
    },
    subscriptionStore() {
      return useSubscriptionStore();
    },
    session() {
      return this.userStore.sessionInfo;
    },
    imageTotal() {
      const total = this.subscriptionStore.clinicUsage?.imageTotal || 0;
      return new Intl.NumberFormat(this.$i18n.locale).format(total);
    },
    locale() {
      return this.session?.currentClinic?.locale?.toLowerCase() || 'en';
    },
    plansUrl() {
      if (this.locale == 'pt-br')
        return 'https://phelcom.com/pt-br/produtos/eyercloud/planos/'
      return 'https://phelcom.com/products/eyercloud/plans/'
    },
  },
  mounted() {
    this.subscriptionStore.updateUsage(this.session.currentClinic.country);
  },
}
</script>
